/* eslint-disable func-names */
/* eslint-disable no-undef */
const video = () => {
  (function ($) {
    const htmlBody = $('html, body');
    const $playBtn = $('.js-play-btn');
    const $closeBtn = $('.js-close-video-btn');
    const $video = $('.c-video');
    const $videoImg = $('.c-video__img');
    const $videoInner = $('.c-video__inner');
    const $videoIframe = $('.c-video__iframe');
    const videoPlaying = 'c-video__iframe--playing';
    const videoInnerHide = 'c-video__inner--hide';
    const videoImgHide = 'c-video__img--hide';
    const videoOpen = 'c-video--open';

    $playBtn.on('click', () => {
      $video.addClass(videoOpen);
      $videoImg.addClass(videoImgHide);
      $videoInner.addClass(videoInnerHide);
      htmlBody.animate({ scrollTop: $video.offset().top - 85 }, 500);
      $videoIframe.addClass(videoPlaying);
      $videoIframe.attr('src', $videoIframe.attr('src').replace('autoplay=0', 'autoplay=1'));
    });

    $closeBtn.on('click', () => {
      $video.removeClass(videoOpen);
      $videoImg.removeClass(videoImgHide);
      $videoInner.removeClass(videoInnerHide);
      $videoIframe.removeClass(videoPlaying);
      $videoIframe.attr('src', $videoIframe.attr('src').replace('autoplay=1', 'autoplay=0'));
    });
  }(jQuery));
};

export default video;
